/**
 * FlowHistoryRef — module-level access to the canvas undo history, so user
 * actions that live in node components (settings, prompt edits, toolbars) can
 * mark an undo step without prop-drilling. Same pattern as FlowStoreRef.
 *
 * Only USER actions call this. Generation handlers, upload completions and
 * measurement effects must never call it — see src/utils/flowHistory.ts.
 */

import type { CheckpointOptions } from '../utils/flowHistory';

export interface FlowHistoryRecorder {
  checkpoint: (label: string, opts?: CheckpointOptions) => void;
  release: (coalesceKey?: string) => void;
}

let current: FlowHistoryRecorder | null = null;

export function registerFlowHistory(recorder: FlowHistoryRecorder): void {
  current = recorder;
}

export function unregisterFlowHistory(recorder?: FlowHistoryRecorder): void {
  if (!recorder || current === recorder) current = null;
}

/** Mark an undo step BEFORE mutating the graph. No-op when no canvas is mounted. */
export function recordUserAction(label: string, opts?: CheckpointOptions): void {
  current?.checkpoint(label, opts);
}

export function releaseUserAction(coalesceKey?: string): void {
  current?.release(coalesceKey);
}
